import { render, staticRenderFns } from "./statisticalReports.vue?vue&type=template&id=d5aabd04"
import script from "./statisticalReports.vue?vue&type=script&lang=js"
export * from "./statisticalReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports